import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button } from '@material-ui/core';
import { useSelector } from 'dva';
import dayjs from 'dayjs';
import { useDispatch } from 'dva';
import { history } from 'umi';
import { fmtThousand, keepDecimal } from '@/utils/comUtil';
import SvgIconML from '@/components/SvgIconML/SvgIconML';
import ReplayIcon from '@material-ui/icons/Replay';
import InfoDetailStyled from './InfoDetailStyled';

const InfoDetail = () => {
  //引入图标
  require('@/assets/img/zjrccjrc.svg');
  require('@/assets/img/zjrscjrs.svg');

  const { id } = history.location?.query;
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState();

  //抽奖活动报表数据
  const fetchLotteryReport = useCallback(() => {
    dispatch({
      type: 'luckyDrawReport/getLotteryReport',
      payload: {
        values: {
          id,
        },
      },
    });
  }, [dispatch, id]);
  //拿抽奖活动报表数据
  useEffect(() => {
    fetchLotteryReport();
  }, [fetchLotteryReport, refresh]);

  const lotteryReportData = useSelector(
    (state) => state.luckyDrawReport?.lotteryReportData,
  );
  const {
    activityName, //活动名称
    beginDateTime, //活动开始时间
    endDateTime, //活动结束时间
    drawNum, //抽奖次数
    drawPeopleNum, //抽奖人数
    winNum, //中奖次数
    winPeopleNum, //中奖人数
    winRate, //中奖率
    perWinRate, //人均中奖率
  } = lotteryReportData || {};
  //刷新
  const handleRefresh = () => {
    setRefresh(new Date());
  };
  return (
    <InfoDetailStyled>
      <Box className="first_section">
        <Box className="left">
          <p className="title">{activityName}</p>
          <p className="time">{`活动时间：${dayjs(beginDateTime).format(
            'YYYY-MM-DD',
          )} ～ ${dayjs(endDateTime).format('YYYY-MM-DD')}`}</p>
        </Box>
        <Box className="right">
          <Button
            variant="contained"
            color="primary"
            className="reset"
            onClick={() => {
              handleRefresh();
            }}
            startIcon={
              <ReplayIcon
                className="replayIcon"
                sx={{
                  width: '16px',
                  height: '16px',
                }}
              />
            }
          >
            刷新
          </Button>
        </Box>
      </Box>
      <Box className="second_section">
        <Box className="campaign_data" pb={1}>
          <Box className="title">
            <SvgIconML size={25} name="campaignData" />
            <span className="title_text">活动数据</span>
          </Box>
          <Box className="data_content" mt={3}>
            <Box>
              <Box className="item_title">
                <SvgIconML size={20} name="peopleNum" /> <span>抽奖人数</span>
              </Box>
              <Box className="item_num" mt={0.5}>
                {fmtThousand(drawPeopleNum)}
              </Box>
            </Box>
            <Box>
              <Box className="item_title">
                <SvgIconML size={20} name="prizeData" />
                <span>抽奖次数</span>
              </Box>
              <Box className="item_num" mt={0.5}>
                {fmtThousand(drawNum)}
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="prize_data" pb={1}>
          <Box className="title">
            <SvgIconML size={25} name="selectData" />
            <span className="title_text">中奖数据</span>
          </Box>
          <Box className="data_content" mt={3}>
            <Box>
              <Box className="item_title">
                <SvgIconML size={20} name="peopleNum" />
                <span>中奖人数</span>
              </Box>
              <Box className="item_num" mt={0.5}>
                {fmtThousand(winPeopleNum)}
              </Box>
              <Box className="wrapper">
                <Box className="hitRate" mt={0.5}>
                  <span className="text">人均中奖率</span>
                  <span className="percent">{keepDecimal(perWinRate, 2)}</span>
                  <span className="floatText scale_10px">%</span>
                </Box>
                <Box className="item_describe">
                  <svg className="icon">
                    <use xlinkHref="#zjrscjrs" />
                  </svg>
                </Box>
              </Box>
            </Box>
            <Box>
              <Box className="item_title">
                <SvgIconML name="prizeData" size={20} />
                <span>中奖次数</span>
              </Box>
              <Box className="item_num" mt={0.5}>
                {fmtThousand(winNum)}
              </Box>
              <Box>
                <Box className="hitRate" mt={0.5}>
                  <span className="text">中奖率</span>
                  <span className="percent">{keepDecimal(winRate, 2)}</span>
                  <span className="floatText scale_10px">%</span>
                </Box>
                <Box className="item_describe">
                  <svg className="icon">
                    <use xlinkHref="#zjrccjrc" />
                  </svg>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </InfoDetailStyled>
  );
};

export default InfoDetail;
